import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, DoCheck,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'yrx-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonComponent implements AfterViewInit, DoCheck {
  constructor(private cdr: ChangeDetectorRef) {
  }

  @Input() size: 'big' | 'normal' | 'small' = 'normal';
  @Input() type: 'primary' | 'secondary' = 'primary'
  @Input() custom: string = ''
  @Input() loading: boolean | null = false
  @Input() disabled: boolean = false
  @Output() press: EventEmitter<any> = new EventEmitter<any>()


  ngAfterViewInit() {
    this.cdr.detectChanges()
  }

  ngDoCheck() {
    this.cdr.detectChanges()
  }
}
